
/**
 * TicketSalesReport.js
 * 用于解析和转换销售数据为表格数据结构
 */

// 全局变量，存储价格列表和员工映射
var priceList = [] // 价格列表，包含priceId、productName、crowdtypeName等信息
// 结算方式
var payTypeList = [
    {type: 0, staffName: '其他'},
    {type: 1, name: '现金'},
    {type: 2, name: '微信'},
    {type: 3, name: '支付宝'},
    {type: 4, name: '工行-微信'},
    {type: 5, name: '工行-支付宝'},
    {type: 6, name: '贵昂-微信'},
    {type: 7, name: '贵昂-支付宝'},
    {type: 8, name: '建行-微信'},
    {type: 9, name: '建行-支付宝'},
] 
// 售票方式
var saleTypelist = [
    {type: 1, name: '售票'},
    {type: 2, name: '退票'},
]
// 业务类型
var businessTypelist = [
    {id: 1, name: '散客业务'},
    {id: 2, name: '旅行社业务'},
    {id: 3, name: '接待业务'},
    {id: 4, name: '其他业务'},

]

/**
 * 解析表格数据
 * @param {Object} apiReturnData - API返回的数据，包含priceList、saleList、refundList等字段
 * @param {Array} staff - 员工列表，包含staffId和staffName等信息
 * @returns {Array} - 转换后的表格数据结构
 */
export const parseTableData = (apiReturnData) => {
    priceList = apiReturnData.priceList
    // staffMap = apiReturnData.staffList
    // staffMap.push({type: 0, staffName: '其他'})
    const saleList = apiReturnData.saleList
    const refundList = apiReturnData.refundList
    
    let paramData = []
    for(let item of saleList){
        let param = paramData.find(param => param.date == item.createDay)
        if(param){
            param.payTypeList = parsePayTypeList(param.payTypeList, item, 1)   

        }else{
            param = {
                date: item.createDay,
                payTypeList: parsePayTypeList([], item, 1),
            }
            paramData.push(param)
        }
    }
    for(let item of refundList){
        let param = paramData.find(param => param.date == item.createDay)
        if(param){
            param.payTypeList = parsePayTypeList(param.payTypeList, item, 2)   

        }else{
            param = {
                date: item.createDay,
                payTypeList: parsePayTypeList([], item, 2),
            }
            paramData.push(param)
        }
    }
    let totalParamData = {
        date: '总计',
        payTypeList: [],
    }
    for(let item of saleList){
        totalParamData.payTypeList = parsePayTypeList(totalParamData.payTypeList, item,1)
    }
    for(let item of refundList){
        totalParamData.payTypeList = parsePayTypeList(totalParamData.payTypeList, item,2) 
    }
    paramData.push(totalParamData)
    return createTableData(paramData)
}

export const parsePayTypeList = (payTypeData, item, saleType) => {
    const payType = payTypeList.find(payType => payType.type == item.payType)

    let payTypeItem = payTypeData.find(payTypeItem => payTypeItem.type == item.payType)
    if(payTypeItem){
        payTypeItem.saleTypeList = parseSaleTypeList(payTypeItem.saleTypeList, item, saleType)   
        
    }else{
        const saleTypeData = parseSaleTypeList([], item,saleType)
        payTypeItem = {
            type: item.payType,
            payName: payType.name,
            saleTypeList: saleTypeData,
        }
        payTypeData.push(payTypeItem)
    }
    return payTypeData
}

export const parseSaleTypeList = (saleTypeData, item, saleType) => {
    const saleTypeObj = saleTypelist.find(sale => sale.type == saleType)
    let saleTypeItem = saleTypeData.find(saleTypeItem => saleTypeItem.type == saleType)
    if(saleTypeItem){
        saleTypeItem.businessTypeList = parseBusinessTypeList(saleTypeItem.businessTypeList, item)
        saleTypeItem.name = saleTypeObj.name
    }else{
        const businessTypeData = parseBusinessTypeList([], item)
        saleTypeItem = {
            type: saleType,
            saleName: saleTypeObj.name,
            businessTypeList: businessTypeData,
        }
        saleTypeData.push(saleTypeItem)
    }
    return saleTypeData
}

export const parseBusinessTypeList = (businessTypeList, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    const businessTypeObj = businessTypelist.find(businessType => businessType.id == price.businesstypeId)
    let businessTypeItem = businessTypeList.find(businessTypeItem => businessTypeItem.id == businessTypeObj.id)
    if(businessTypeItem){
        businessTypeItem.productList = parseProductList(businessTypeItem.productList, item)
        businessTypeItem.name = businessTypeObj.name
    }else{
        const productData = parseProductList([], item)
        businessTypeItem = {
            businessName: businessTypeObj.name,
            productList: productData,
        }
        businessTypeList.push(businessTypeItem)
    }
    return businessTypeList
}

export const parseProductList = (productList, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let productParam = productList.find(product => product.productName == price.productName)
    if(productParam){
        productParam.priceList = parsePriceList(productParam.priceList, item)
    }else{
        const priceData = parsePriceList([], item)
        productParam = {
            productName: price.productName,
            priceList: priceData,
        }
        productList.push(productParam)
    }
    return productList
}

export const parsePriceList = (priceData, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let priceParam = priceData.find(priceData => priceData.crowdtypeName == price.crowdtypeName)
    if(priceParam){
        priceParam.salePrice = parseSalePrice(priceParam.salePrice, item)
    }else{
        const salePrice = parseSalePrice([], item)
        priceParam = {
            crowdtypeName: price.crowdtypeName,
            salePrice: salePrice,
        }
        priceData.push(priceParam)
    }
    return priceData
}

export const parseSalePrice = (salePriceList, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let salePriceParam = salePriceList.find(price => price.price == price.settlementPrice)
    if(salePriceParam){
        salePriceParam.quantityList = parseQuantity(salePriceParam.quantityList, item)
    }else{
        const quantityList = parseQuantity([], item)
        salePriceParam = {
            price: price.salePrice,
            quantityList: quantityList,
        }
        salePriceList.push(salePriceParam)
    }
    return salePriceList
}

export const parseQuantity = (quantityList, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let quantityParam = quantityList.find(quantity => quantity.price == price.salePrice)
    if(quantityParam == null){
        quantityParam = {
            quantity: 0,
            sealQuantity: 0,
            smallCount: 0,
            payCount: 0,
        }
    }
    // 退票数量
    if(item.operateQuantity && item.operateQuantity > 0){
        quantityParam.quantity = quantityParam.quantity - item.operateQuantity
        quantityParam.sealQuantity = quantityParam.sealQuantity - item.operateQuantity
        quantityParam.smallCount = quantityParam.smallCount - (item.operateQuantity * price.salePrice)
        quantityParam.payCount = quantityParam.payCount - (item.operateQuantity * price.salePrice)
    }
    // 售票数量
    if(item.quantity && item.quantity > 0){
        quantityParam.quantity = quantityParam.quantity + item.quantity
        quantityParam.sealQuantity = quantityParam.sealQuantity + item.quantity
        quantityParam.smallCount = quantityParam.smallCount + (item.quantity * price.salePrice)
        quantityParam.payCount = quantityParam.payCount + (item.quantity * price.salePrice)

    }
    return quantityParam
}

export const createTableData = (paramData) => {
    let tableData = []
    let i = 1
    for(let param of paramData){
        let productRow = []
        let bigQuantity = 0
        let bigOperateQuantity = 0
        let bigSealQuantity = 0
        let bigSmallCount = 0
        let bigPayCount = 0
        for(let payType of param.payTypeList){
            let payTypeRow = []
            let smallQuantity = 0
            let smallOperateQuantity = 0
            let smallSealQuantity = 0
            let smallSmallCount = 0
            let smallPayCount = 0
            for(let saleType of payType.saleTypeList){
                let saleTypeList = []
                for(let businessType of saleType.businessTypeList){
                    let staffList = []
                    
                    for(let product of businessType.productList){
                        // let productList = []
                        for(let price of product.priceList){
                            // let priceList = []
                            for(let salsePrice of price.salePrice){
                                // let salePriceRow = []
                                let tr = [
                                    { value: param.date, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                                    { value: payType.payName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                                    { value: saleType.saleName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                                    { value: businessType.businessName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                                    { value: product.productName, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                                    { value: price.crowdtypeName, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                                    { value: salsePrice.price/100, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                                    { value: salsePrice.quantityList.quantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                                    { value: salsePrice.quantityList.sealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                                    { value: salsePrice.quantityList.payCount/100, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                                ]
                                staffList.push({ tr: tr })
                                smallQuantity = smallQuantity + salsePrice.quantityList.quantity
                                smallOperateQuantity = smallOperateQuantity + salsePrice.quantityList.operateQuantity
                                smallSealQuantity = smallSealQuantity + salsePrice.quantityList.sealQuantity
                                smallSmallCount = smallSmallCount + salsePrice.quantityList.smallCount
                                smallPayCount = smallPayCount + salsePrice.quantityList.payCount
                                bigQuantity = bigQuantity + salsePrice.quantityList.quantity
                                bigOperateQuantity = bigOperateQuantity + salsePrice.quantityList.operateQuantity
                                bigSealQuantity = bigSealQuantity + salsePrice.quantityList.sealQuantity
                                bigSmallCount = bigSmallCount + salsePrice.quantityList.smallCount
                                bigPayCount = bigPayCount + salsePrice.quantityList.payCount
                            }
                            
                        }
                        
                    }
                    
                    staffList[0].tr[3].rowspan = staffList.length
                    staffList[0].tr[3].colspan = 1
                    saleTypeList.push(...staffList)
                   
                }
                
                
                saleTypeList[0].tr[2].rowspan = saleTypeList.length
                saleTypeList[0].tr[2].colspan = 1
                payTypeRow.push(...saleTypeList)
                
            }
             let tr = [
                { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                { value: '小计', colspan: 5, rowspan: 1, class: 'qa-td-subtotal' },
                { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                { value: smallQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                // { value: smallOperateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                { value: smallSealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                { value: smallPayCount/100, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
            ]
            payTypeRow.push({ tr: tr })
            
            payTypeRow[0].tr[1].rowspan = payTypeRow.length
            payTypeRow[0].tr[1].colspan = 1
            productRow.push(...payTypeRow)
        }
        let tr = [
            { value: '', colspan: 0, rowspan: 0, class: 'qa-td-total' },
            { value: '合计', colspan: 6, rowspan: 1, class: 'qa-td-total' },
            { value: '', colspan: 0, rowspan: 0, class: 'qa-td-total' },
            { value: bigQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            // { value: bigOperateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigSealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigPayCount/100, colspan: 1, rowspan: 1, class: 'qa-td-total' },
        ]
        productRow.push({ tr: tr })
        productRow[0].tr[0].rowspan = productRow.length
        productRow[0].tr[0].colspan = 1
        if(i == paramData.length){
            productRow[0].tr[0].class = 'qa-td-merged qa-th-merged'
        }
        tableData.push(...productRow)
        i++
    }
    return tableData
}




